import React from "react";
import { Link } from "react-router-dom";
import { APP_LINKS, SITE } from "@/lib/site";
import { DEFAULT_REGION, POLICY_LINKS, REGIONS, REGION_ORDER, policyHref } from "@/lib/policies";

export default function Footer() {
  return (
    <footer className="py-12 bg-white border-t border-sky-100">
      <div className="container-x grid md:grid-cols-12 gap-8 items-start">
        <div className="md:col-span-4">
          <div className="flex items-center gap-3">
            <img src={SITE.logo} alt="Wateriia" className="h-10 w-10 object-contain" />
            <div>
              <div className="font-bold text-[#0b1d2a]">Wateriia India</div>
              <div className="text-[11px] uppercase tracking-[0.22em] text-slate-500">{SITE.shortAddress}</div>
            </div>
          </div>
          <p className="mt-4 text-sm text-slate-500 max-w-md">
            Pure water, delivered smarter. App-first water supply network for Bengaluru and beyond.
          </p>
        </div>

        <div className="md:col-span-2">
          <div className="eyebrow">Sitemap</div>
          <ul className="mt-3 space-y-1.5 text-sm text-slate-600">
            <li><a href="/#about" className="link-x">About</a></li>
            <li><a href="/#services" className="link-x">Services</a></li>
            <li><a href="/#why" className="link-x">Why Wateriia</a></li>
            <li><a href="/#partner" className="link-x">Partner</a></li>
            <li><a href="/#contact" className="link-x">Contact</a></li>
          </ul>
        </div>

        {/* Legal — every document the app store listings link to. */}
        <div className="md:col-span-3">
          <div className="eyebrow">Legal &amp; Policies</div>
          <ul className="mt-3 space-y-1.5 text-sm text-slate-600">
            {POLICY_LINKS.map((p) => (
              <li key={p.slug}>
                <Link
                  data-testid={`footer-policy-${p.slug}`}
                  to={policyHref("in", p.slug)}
                  className="link-x"
                >
                  {p.label}
                </Link>
              </li>
            ))}
          </ul>
          <div className="mt-4 text-xs text-slate-500">
            Ordering from another market? Read the policies for{" "}
            {REGION_ORDER.filter((k) => k !== DEFAULT_REGION).map((k, i, arr) => (
              <React.Fragment key={k}>
                <Link
                  data-testid={`footer-policy-region-${k}`}
                  to={policyHref(k, "privacy-policy")}
                  className="link-x font-medium text-[#0369a1]"
                >
                  {REGIONS[k].label}
                </Link>
                {i < arr.length - 2 ? ", " : i === arr.length - 2 ? " or " : "."}
              </React.Fragment>
            ))}
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="eyebrow">Get in touch</div>
          <ul className="mt-3 space-y-1.5 text-sm text-slate-600">
            <li>{SITE.address}</li>
            <li><a href={`tel:${SITE.phoneTel}`} className="link-x">{SITE.phoneDisplay}</a></li>
            <li><a href={`mailto:${SITE.email}`} className="link-x">{SITE.email}</a></li>
          </ul>
          <div className="eyebrow mt-6">Get the app</div>
          <ul className="mt-3 space-y-1.5 text-sm text-slate-600">
            <li>
              <a data-testid="footer-app-store" href={APP_LINKS.ios} target="_blank" rel="noopener noreferrer" className="link-x">
                App Store (iPhone)
              </a>
            </li>
            <li>
              <a data-testid="footer-play-store" href={APP_LINKS.android} target="_blank" rel="noopener noreferrer" className="link-x">
                Google Play (Android)
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="container-x mt-10 pt-6 border-t border-sky-100 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
        <div>© {new Date().getFullYear()} Wateriia India. All rights reserved.</div>
        <div>Made for {SITE.city}, {SITE.region}.</div>
      </div>
    </footer>
  );
}
